import React from "react";
import OverviewSection from "~/assets/js/pages/Checkout/sections/OrderOverview/OverviewSection";
import i18next from "i18next";
import PAYMENT_OPTIONS from "~/assets/js/Helpers/paymentOptions";
import PropTypes from "prop-types";

const OrderTypeOfPayment = ({ paymentOption }) => {
    // No payment was required for this order
    if (["none", ""].includes(paymentOption)) {
        return null;
    }

    const { iconPath } = reactConfig;

    const selectedPayment = PAYMENT_OPTIONS.find(
        (payment) => payment.value === paymentOption
    );

    if (!selectedPayment) {
        return null;
    }

    const { icons, heading } = selectedPayment;

    return (
        <OverviewSection title="overview.payment">
            <div className="togglebox togglebox_payment">
                <span className="togglebox__title">{i18next.t(heading)}</span>
                {icons.map((icon) => {
                    return (
                        <div className={"togglebox__icon"} key={icon}>
                            <img
                                src={`${iconPath}/${icon}`}
                                alt="icon"
                                key={icon}
                            />
                        </div>
                    );
                })}
            </div>
        </OverviewSection>
    );
};

OrderTypeOfPayment.propTypes = {
    paymentOption: PropTypes.string.isRequired,
};

export default OrderTypeOfPayment;
